import { CloseCommissionPeriodResponse, CommissionOverviewResponse, CommissionPayee, CommissionRatesResponse, CommissionSellerDetailResponse, MyCommissionLinesResponse, MyCommissionResponse, SetCommissionRateResponse, } from '@aeris/contracts';
import { clientTimeZone, request } from "./client.js";
/**
 * `/api/v1/commissions` — comissão dos vendedores (F137).
 *
 * O fuso vai junto, como no painel e na cobrança: o mês é o mês no relógio da
 * loja, e a venda das 23h do último dia é daquele mês, não do seguinte em UTC.
 */
const pad = (value) => String(value).padStart(2, '0');
/** O mês de uma data no relógio de quem olha: `2026-09`. */
export const periodOf = (date) => `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}`;
/** `2026-09` ± meses. */
export const shiftPeriod = (period, months) => {
    const [year = '1970', month = '01'] = period.split('-');
    return periodOf(new Date(Number.parseInt(year, 10), Number.parseInt(month, 10) - 1 + months, 1));
};
/** `2026-09` → `setembro de 2026`. */
export const periodLabel = (period) => {
    const [year = '1970', month = '01'] = period.split('-');
    return new Intl.DateTimeFormat('pt-BR', {
        month: 'long',
        year: 'numeric',
    }).format(new Date(Number.parseInt(year, 10), Number.parseInt(month, 10) - 1, 15));
};
/** `2026-09` → `09/2026`. */
export const periodShort = (period) => {
    const [year = '', month = ''] = period.split('-');
    return `${month}/${year}`;
};
const periodQuery = (period) => new URLSearchParams({ period, timeZone: clientTimeZone() }).toString();
export const fetchCommissionOverview = async (period, signal) => CommissionOverviewResponse.parse(await request(`/api/v1/commissions?${periodQuery(period)}`, {
    ...(signal ? { signal } : {}),
}));
export const fetchCommissionSeller = async (userId, period, signal) => CommissionSellerDetailResponse.parse(await request(`/api/v1/commissions/sellers/${userId}?${periodQuery(period)}`, { ...(signal ? { signal } : {}) }));
export const fetchMyCommission = async (period, signal) => MyCommissionResponse.parse(await request(`/api/v1/commissions/me?${periodQuery(period)}`, {
    ...(signal ? { signal } : {}),
}));
/** As vendas e trocas de quem está logado no mês, uma a uma (F215). */
export const fetchMyCommissionLines = async (period, signal) => MyCommissionLinesResponse.parse(await request(`/api/v1/commissions/me/lines?${periodQuery(period)}`, {
    ...(signal ? { signal } : {}),
}));
/** O dia de um instante no relógio de quem olha: `2026-09-30` (F215). */
export const dayOf = (value) => {
    const date = typeof value === 'string' ? new Date(value) : value;
    return `${periodOf(date)}-${pad(date.getDate())}`;
};
export const fetchCommissionRates = async (signal) => CommissionRatesResponse.parse(await request('/api/v1/commissions/rates', {
    ...(signal ? { signal } : {}),
}));
/** A %, de agora ou desde o começo de um mês (`since`, F235), no fuso da loja. */
export const setCommissionRate = async (input) => SetCommissionRateResponse.parse(await request('/api/v1/commissions/rates', {
    method: 'POST',
    body: { ...input, timeZone: clientTimeZone() },
}));
export const setCommissionPayee = async (userId, input) => CommissionPayee.parse(await request(`/api/v1/commissions/payees/${userId}`, {
    method: 'PUT',
    body: input,
}));
/** Cadastra a pessoa da equipe como Pessoa e a põe como quem recebe (F235). */
export const registerCommissionPayeeParty = async (userId, input) => CommissionPayee.parse(await request(`/api/v1/commissions/payees/${userId}/party`, {
    method: 'POST',
    body: input,
}));
export const closeCommissionPeriod = async (input) => CloseCommissionPeriodResponse.parse(await request('/api/v1/commissions/close', {
    method: 'POST',
    body: { ...input, timeZone: clientTimeZone() },
}));
export const voidCommissionStatement = async (id, input) => {
    await request(`/api/v1/commissions/statements/${id}/void`, {
        method: 'POST',
        body: input,
    });
};
//# sourceMappingURL=commissions.js.map